interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage' | 'BreadcrumbList';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const getSchema = (): Record<string, unknown> => {
    const baseOrg = {
      '@type': 'Organization',
      name: '17c.com GitHub 资源汇总',
      url: 'https://17c.com',
      description: '专注于 GitHub 开源项目的资源聚合平台，提供全面的项目解析、使用教程和开发工具推荐。',
    };

    const baseWebSite = {
      '@type': 'WebSite',
      name: '17c.com GitHub 完整指南与资源汇总',
      url: 'https://17c.com',
      description: '涵盖 17c.com GitHub 项目结构、使用教程、开源资源获取及常见问题解答。',
      inLanguage: 'zh-CN',
    };

    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          ...baseOrg,
        };

      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          ...baseWebSite,
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: 'https://17c.com/search?q={search_term_string}',
            },
            'query-input': 'required name=search_term_string',
          },
        };

      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: data.name || '17c.com GitHub 资源汇总',
          description: data.description || '',
          url: data.url || 'https://17c.com',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: '17c.com GitHub 资源汇总',
            url: 'https://17c.com',
          },
          ...(data.breadcrumb && { breadcrumb: data.breadcrumb }),
        };

      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: data.headline || '',
          description: data.description || '',
          author: {
            '@type': 'Organization',
            name: data.author || '17c 技术团队',
          },
          datePublished: data.datePublished || '',
          dateModified: data.dateModified || data.datePublished || '',
          inLanguage: 'zh-CN',
          publisher: {
            '@type': 'Organization',
            name: '17c.com',
          },
        };

      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: (data.questions as Array<{ question: string; answer: string }> || []).map((q) => ({
            '@type': 'Question',
            name: q.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: q.answer,
            },
          })),
        };

      case 'BreadcrumbList':
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: (data.items as Array<{ name: string; item: string }> || []).map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: item.item,
          })),
        };

      default:
        return {};
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getSchema()) }}
    />
  );
}